// extracted by mini-css-extract-plugin
module.exports = {"problems-items":"ProblemsItems_problems-items_1v7KL","problems-items-paragraph-company":"ProblemsItems_problems-items-paragraph-company_3zwpS"};